import React, { useState } from 'react'
import { connect } from 'react-redux'
import { removeBackupEmail } from '../../actions/user'
import { dismissEmailVerificationPrompt } from '../../actions/emailVerification'
import { hideModal } from '../../actions/modals'
import { showNotification } from '../../actions/notifications'
import ReauthenticationModal from '../../components/reauthenticationModal/ReauthenticationModal'
import Button from '../../components/uiKit/Button'
import handleAccountRequest from './utils/handleAccountRequest'

function RemoveBackupEmailContainer(props) {
  const {
    hideModal,
    showNotification,
    removeBackupEmail,
    dismissEmailVerificationPrompt,
    user,
  } = props
  const [showReauthenticationModal, setShowReauthenticationModal] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  function onAuthenticate(authentication) {
    handleAccountRequest({
      setSubmitLoading,
      setErrorMessage,
      makeRequest: () => removeBackupEmail(user.id, {
        type: 'password',
        password: authentication.password,
      }).then((response) => {
        // suppress the "add a backup email" nag from popping back up right
        // after the user just deliberately removed theirs
        dismissEmailVerificationPrompt(user.id, 'addBackup').catch(() => {})
        return response
      }),
      hideModal,
      showSuccessNotification: () => showNotification('Backup Email', 'Removed', 'default'),
      requestName: 'removeBackupEmail',
    })
  }

  return (
    <div className='accountAuthentication is--remove'>
      <div className='accountAuthentication-explanationText'>
        Please confirm that you would like to remove your backup email
      </div>
      <div className='accountAuthentication-emailBox'>
        <div className='accountAuthentication-emailBox-label'>Backup Email</div>
        <div className='accountAuthentication-emailBox-email'>{user.backupEmail}</div>
      </div>
      <div className='accountAuthentication-actionRow'>
        <Button
          size='large'
          label='Confirm'
          color='blue'
          type='submit'
          onClickFunction={() => setShowReauthenticationModal(true)}
          submitLoading={submitLoading}
        />
      </div>

      {errorMessage && (
      <div className='accountAuthentication-error'>
        {errorMessage}
      </div>
      )}

      {showReauthenticationModal && (
        <ReauthenticationModal
          title='Remove Backup Email'
          signinMethodsToDisplay={{ password: true }}
          onAuthenticate={(authentication) => onAuthenticate(authentication)}
          hideModal={() => setShowReauthenticationModal(false)}
        />
      )}
    </div>
  )
}

export default connect(
  (state) => ({
    user: state.user,
  }),
  {
    removeBackupEmail,
    dismissEmailVerificationPrompt,
    hideModal,
    showNotification,
  },
)(RemoveBackupEmailContainer)
